function cloneElBottomBracket(el) {
  const bottomBracket = el.querySelector(
    ".eza-bottom-bracket-wrapper:last-child",
  );
  if (!bottomBracket) return;
  if (bottomBracket.dataset.initialized) return;
  const mediaEl = el.querySelector(".eza-media");
  if (!mediaEl) return;
  mediaEl.append(bottomBracket.cloneNode(true));
  bottomBracket.dataset.initialized = true;
}

function cloneMedia(el) {
  if (el.dataset.initialized) return;

  const contentEl = el.querySelector(".eza-content");
  if (!contentEl) return;
  if (!contentEl.children.length) return;

  const mediaEl = el.querySelector(".eza-media *");
  if (!mediaEl) return;

  const cloneEl = mediaEl.cloneNode(true);
  cloneEl.removeAttribute("data-position-sticky");
  cloneEl.setAttribute("style", "position: relative"); // this removes any sticky/top positioning

  let insertionPointEl = contentEl.querySelector(".eza-insertion-point");
  if (!insertionPointEl)
    insertionPointEl = contentEl.children[Math.floor(contentEl.children / 2)];
  insertionPointEl.after(cloneEl);

  el.dataset.initialized = true;
}

// duplicates bottom brackets as needed to make the layout show as expected
function initBlocksWithMedia() {
  const els = document.querySelectorAll(".eza-blocks-with-media");
  els.forEach((el) => {
    if (el.classList.contains("eza-mobile-order-blocks,media"))
      cloneElBottomBracket(el);
    if (el.classList.contains("eza-mobile-order-media-in-blocks"))
      cloneMedia(el);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBlocksWithMedia);
} else {
  initBlocksWithMedia();
}
